import { render } from "./userComponent.vue?vue&type=template&id=181b523f"
import script from "./userComponent.vue?vue&type=script&lang=js"
export * from "./userComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__